import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { CloseIcon } from '@/assets/images';
import { CustomButton } from '@/components';
import './Popup.scss';

function Popup({ isOpen, onClose, children, title, hideHeader, isTop = true, disableOverlayClick = false, className }) {
   if (!isOpen) return null;

   const handleOverlayClick = e => {
      if (!disableOverlayClick && e.target === e.currentTarget) {
         onClose();
      }
   };

   const popupContent = (
      <CustomButton
         as="div"
         className={`popup-overlay ct-flex ct-aiCenter ct-jcCenter ${!isTop ? 'popup-stacked-hidden' : ''}`}
         onClick={handleOverlayClick}
         aria-label={title || 'Close'}
         aria-hidden={!isOpen}
      >
         <CustomButton
            as="div"
            className={['popup-container', 'ct-flex', 'ct-fcol', className].filter(Boolean).join(' ')}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
         >
            {!hideHeader && (
               <div className="popup-header">
                  <h2 className="popup-title ct-text-center">{title}</h2>
                  <button type="button" className="popup-close-btn ct-cursor" onClick={onClose}>
                     <CloseIcon />
                  </button>
               </div>
            )}
            <div className={`popup-body ct-flex1 ct-flex ct-fcol ct-scroll ${hideHeader ? 'no-header' : ''}`}>
               {children}
            </div>
         </CustomButton>
      </CustomButton>
   );

   return createPortal(popupContent, document.body);
}

Popup.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   title: PropTypes.string,
   hideHeader: PropTypes.bool,
   isTop: PropTypes.bool,
   disableOverlayClick: PropTypes.bool,
   children: PropTypes.node,
   className: PropTypes.string,
};

export default Popup;
